import React, { useState, useEffect, useCallback } from "react";
import CoachLayout from "../common/CoachLayout";
import { CoachHeader } from "../common/CoachHeader";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import API_URL from "../../api/API";

export const CoachPurchaseTransactions = () => {
  const { coach } = useCoachAuthContext();
  const [speedTransactions, setSpeedTransactions] = useState([]);
  const [strengthTransactions, setStrengthTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTransactions = useCallback(async () => {
    if (coach) {
      try {
        const response = await fetch(`${API_URL.GET_COACH_PURCHASE_DATA}${coach.id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${coach.token}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          // Separate speed and strength transactions
          setSpeedTransactions(data.speed || []); // Default to an empty array if speed is not present
          setStrengthTransactions(data.strength || []); // Default to an empty array if strength is not present
        } else {
          throw new Error(data.error || "Failed to fetch transactions");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  }, [coach]);

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  return (
    <div className="bg-white min-h-screen">
      <CoachLayout>
        <div className="bg-white min-h-full">
          <CoachHeader />
          <div className="container mx-auto p-6">
            <h2 className="text-2xl font-bold mb-4">Purchase Transactions</h2>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            {loading ? (
              <p>Loading transactions...</p>
            ) : speedTransactions.length === 0 && strengthTransactions.length === 0 ? (
              <p>No transactions available.</p>
            ) : (
              <div className="max-h-[500px] overflow-y-auto border border-gray-200 rounded-lg">
                {speedTransactions.length > 0 && (
                  <>
                    <h3 className="text-lg font-semibold mt-4 mb-2">Speed Templates</h3>
                    <ul className="divide-y divide-gray-300">
                      {speedTransactions.map((transaction) => (
                        <li key={transaction._id} className="py-4 flex justify-between px-4">
                          <div>
                            <p className="text-sm font-semibold">
                              Template: {transaction.template_id}
                            </p>
                            <p className="text-gray-700">
                              Payment Status: {transaction.payment_status}
                            </p>
                            <p className="text-gray-700">Price: ${transaction.price}</p>
                          
                          </div>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                {strengthTransactions.length > 0 && (
                  <>
                    <h3 className="text-lg font-semibold mt-4 mb-2">Strength Templates</h3>
                    <ul className="divide-y divide-gray-300">
                      {strengthTransactions.map((transaction) => (
                        <li key={transaction._id} className="py-4 flex justify-between px-4">
                          <div>
                            <p className="text-sm font-semibold">
                              Template: {transaction.template_id}
                            </p>
                            <p className="text-gray-700">
                              Payment Status: {transaction.payment_status}
                            </p>
                            <p className="text-gray-700">Price: ${transaction.price}</p>
                           
                          </div>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </CoachLayout>
    </div>
  );
};
